import React from "react";
import "./ApiProducts.css";

const ApiProducts = () => {
  const apiProducts = [
    {
      id: 1,
      title: "Recharge API",
      description:
        "Mobile & DTH recharge APIs with fast processing and live status updates",
      icon: "⚡",
      color: "primary",
      tags: ["Mobile", "DTH", "Fast"],
    },
    {
      id: 2,
      title: "Bill Payment API",
      description:
        "Utility bill payments for electricity, water, gas, and broadband",
      icon: "🧾",
      color: "success",
      tags: ["Utility", "Bills", "Secure"],
    },
    {
      id: 3,
      title: "NSDL PAN Card API",
      description:
        "Assisted Aadhaar e-KYC PAN applications with real-time tracking",
      icon: "🆔",
      color: "warning",
      tags: ["PAN", "NSDL", "e-KYC"],
    },
    {
      id: 4,
      title: "UTI PAN Card API",
      description:
        "End-to-end PAN services with agent registration and coupon flow",
      icon: "📋",
      color: "info",
      tags: ["PAN", "UTI", "Agent"],
    },
    {
      id: 5,
      title: "Insurance POSP API",
      description:
        "End-to-end insurance journeys with SSO auto-login and policy issuance",
      icon: "🛡️",
      color: "primary",
      tags: ["Insurance", "POSP", "SSO"],
    },
    {
      id: 6,
      title: "Lead Generation API",
      description:
        "Credit card & bank account lead generation with verified, actionable leads",
      icon: "📈",
      color: "success",
      tags: ["Leads", "Banking", "Verified"],
    },
    {
      id: 7,
      title: "Gift Voucher API",
      description:
        "Digital gift vouchers from leading brands with instant delivery",
      icon: "🎁",
      color: "warning",
      tags: ["Gift", "Brands", "Digital"],
    },
    // {
    //   id: 8,
    //   title: "Payment Gateway API",
    //   description: "Partnered PAPG payment gateway with high success rates",
    //   icon: "💳",
    //   color: "info",
    //   tags: ["PG", "Partner", "Secure"],
    // },
    // {
    //   id: 9,
    //   title: "PPI Fund Transfer API",
    //   description:
    //     "Instant PPI wallet transfers with IMPS and live transaction tracking",
    //   icon: "💰",
    //   color: "primary",
    //   tags: ["PPI", "IMPS", "Instant"],
    // },
    {
      id: 10,
      title: "Verification API",
      description:
        "Instant verification for PAN, Aadhaar, bank account, and UPI ID",
      icon: "✅",
      color: "success",
      tags: ["KYC", "Aadhaar", "Verification"],
    },
  ];

  const colorStyles = {
    primary: { bg: "rgba(13, 110, 253, 0.08)", text: "#0d6efd" },
    success: { bg: "rgba(25, 135, 84, 0.08)", text: "#198754" },
    warning: { bg: "rgba(255, 193, 7, 0.08)", text: "#ffc107" },
    info: { bg: "rgba(13, 202, 240, 0.08)", text: "#0dcaf0" },
  };

  return (
    <section className="py-5 bg-white">
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5">
          <h4 className="title mb-4">Comprehensive API Suite for Every Need</h4>
          <p className="text-muted lead mb-0">
            From recharges to payments, verification to leads - we provide APIs
            for every aspect of your business.
          </p>
        </div>

        {/* API Cards Grid */}
        <div className="row g-4">
          {apiProducts.map((api) => (
            <div className="col-lg-4 col-md-6" key={api.id}>
              <div className="card border-0 h-100 shadow-sm hover-lift">
                <div className="card-body p-4">
                  <div className="d-flex align-items-start">
                    {/* Icon with better background */}
                    <div
                      className="flex-shrink-0 rounded-circle d-flex align-items-center justify-content-center me-3"
                      style={{
                        width: "56px",
                        height: "56px",
                        border: `2px solid ${colorStyles[api.color].text}`,
                        fontSize: "24px",
                        color: colorStyles[api.color].text,
                      }}
                    >
                      {api.icon}
                    </div>

                    {/* Content */}
                    <div className="flex-grow-1">
                      <h5 className="fw-semibold mb-2">{api.title}</h5>
                      <p className="text-muted small mb-3">{api.description}</p>

                      {/* Tags */}
                      {/* <div className="d-flex flex-wrap gap-1">
                        {api.tags.map((tag, index) => (
                          <span
                            key={index}
                            className="badge bg-light text-dark px-2 py-1"
                            style={{
                              fontSize: "0.75rem",
                              border: `1px solid ${colorStyles[api.color].bg}`,
                            }}
                          >
                            {tag}
                          </span>
                        ))}
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ApiProducts;
